module.exports = __webpack_public_path__ + "assets/img/29_295.6af6025e.jpg";